/* eslint-disable import/prefer-default-export */
import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

// export const getCitiesData = params =>
//   axios.get(`${API_HOST}/city/list`, {
//     params,
//     withCredentials: true
//   });
export const getCitiesData = params =>
  axios.get(`${API_HOST}/city/list`, {
    params,
    withCredentials: true
  });
